export enum NotificationType {
    Review,
    SocialPost,
    SocialReply,
    Ticket,
    ScheduledLocationPost,
    Mention,
    SurveyResult,
    SurveyResponse,
    SocialPostApproval,
    // GoogleQA, // Deprecated: Google My Business Q&A API discontinued on November 3, 2025
    Summary,
    Survey1,
    ReviewResponseApproval,
    SurveyResponseApproval,
    DataCollectionStatus,
    InboxMessage,
    InboxConversation,
    InboxAssignment,
    Credential,
    Integration,
    Listings,
    OutReach,
    DuplicateProfiles,
    ProfileErrorListings,
    ProfileChangeListings,
    ListingVerification,
    CredentialMatching,
    CredentialSummary,
    TicketResponse,
    SocialNonAPIPost,
    SocialPostReplyResponseApproval,
    PublisherSuggestions,
    MessageResponseApproval,
    InboxConversationUpdate,
    ActionPlan,
    Review3,
    Review3ResponseApproval,
    ElasticReview,
    FieldsMissingOnProfiles,
}

export enum NotificationChannel {
    Email,
    Sms,
    Push,
    InApp,
    CommandCenter,
}

export enum Frequency {
    Immediate,
    Daily,
    Weekly,
    Monthly,
    Quarterly,
}

export enum DayOfWeek {
    Sunday = 1,
    Monday,
    Tuesday,
    Wednesday,
    Thursday,
    Friday,
    Saturday,
}

export interface NotificationHistory {
    id: string;
    notificationID: string;
    agencyID?: number;
    tenantID: string;
    userID: string;
    sentDate: number;
    objectID: string;
    type: NotificationType;
    channel: NotificationChannel;
    subject: string;
    from: EmailUser;
    to: EmailUser;
    payload: string;
    viewed: boolean;
    status: NotificationHistoryStatus;
    [propName: string]: any;
    eventType: string;
}

export enum NotificationHistoryStatus {
    UnRead,
    Read,
    RemindMeLater,
}

export interface EmailUser {
    name: string;
    email: string;
}

export interface GroupNotificationHistory {
    [key: string]: NotificationHistory[];
}

export interface UpdateNotificationStatuses {
    userId: string;
    status: NotificationHistoryStatus;
}

export interface UpdateRemindMeStatus {
    notificationHistoryID: string;
}

export interface UpdateNotificationStatus {
    id: string;
    status: NotificationHistoryStatus;
}

export interface NotificationLink {
    url: string;
}

export interface NotificationDataType {
    id: string;
    created: number;
    updated: number;
    agencyID: number;
    tenantID: number;
    userID: number;
    type: NotificationType;
    channels: NotificationChannel[];
    externalID: any;
    filters: any[];
    parameters?: {
        [key: string]: string[];
    };
    activeNotification: boolean;
    name: string;
    lambdaID: any;
    notificationSchedule: NotificationScheduleType;
    roleID: string;
    parentNotificationID: any;
    customMessage: any;
    cID: number;
    uID: number;
    batch: boolean;
    hide: boolean;
    syncStatus: number;
    originalSourceID: any;
}

export enum NotificationFrequency {
    Immediate = 0,
    Daily,
    Weekly,
    Monthly,
    Quarterly,
}

export interface NotificationScheduleType {
    subject: string;
    body: any;
    frequency: NotificationFrequency;
    frequencyLabel?: string;
    active: boolean;
    sentDate: any;
    nextDate: number;
    distributions: any[];
    format: number;
    daysOfWeek: number[];
    daysOfMonth: any;
}

export interface PollNotificationHistoriesResponse {
    notifications: NotificationHistory[];
    totalUnreadCount: number;
}

export interface DesktopAlert {
    id: string;
    agencyID: number | undefined;
    tenantID: string;
    userID: string;
    objectIDs: string[];
    notificationHistoryIDs: string[];
    eventType: string;
    createdDate: number;
    payload?: string | 'New notification';
    impactAnalysis?: string | 'Addressing it promptly will protect your reputation from further impact.';
    title?: string | 'New notification';
    message?: string | 'Addressing it promptly will protect your reputation from further impact.';
    metadata?: Record<string, any>;
}
